class Territory {
    constructor(age, name, text, effect)
    {
        this.age = age;
        this.name = name;
        this.text = text;
        this.effect = effect;
    }

    GetAge() {
        return this.age;
    }

    GetName() {
        return this.name;
    }

    GetText() {
        return this.text;
    }

    GetEffects() {
        return this.effect;
    }
}

module.exports = Territory;